export default "__VITE_ASSET__CKPG5hiK__"